import { useAppStore } from './app/appStore';
import { useTinybaseStore } from './tinybase/tinybaseStore';

export const clearStore = () => {
  useAppStore.getState().clear();
  useTinybaseStore.getState().clear();
};
